import * as React from 'react';
import style from './MembersList.scss';
import { sectionPrefix } from '../../../../../NavigationMenu/utils';
import { getName } from '../../../../../../../utils/treeVisitors/helpers';
import { MEMBER_TYPES } from '..';
import { CustomLink } from '../../../../../PageElements/CustomLink';
import { getShortSummary } from './utils';
import { LoggerContext } from '../../../../../../appContext/LoggerProvider';
import { NAV_TYPES } from '../../../../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { transformNodeKeyToDocsUrl } from '../../../../../../../utils/flattenTree/utils';
import { StoreContext } from '../../../../../../appContext/StoreProvider';
import { logNavigationClickFromLink } from '../../../../../../LoggerFactory/BiAnalyticsLogger/events';
import { Text } from '../../../../../PageElements/Text';

export const MembersList = React.memo(
  ({ members, prefix, type, memberDataHook, nameRenderer }) => {
    const { logger } = React.useContext(LoggerContext);
    const { store } = React.useContext(StoreContext);
    const getLink = (urlFormat) => {
      const _prefix = sectionPrefix(prefix, urlFormat);
      return `/${_prefix}`;
    };

    const getMemberName = (member) => {
      const name = getName(member);
      return type === MEMBER_TYPES.function ||
        type === MEMBER_TYPES.clientEvents
        ? `${name}( )`
        : name;
    };

    const onLinkClicked = (member) => {
      const { urlFormat } = member;
      const link = `/${prefix}${
        urlFormat ? `/${transformNodeKeyToDocsUrl(urlFormat)}` : ''
      }`;
      logNavigationClickFromLink(logger, link, store, NAV_TYPES.INDEX_PAGE);
    };

    return (
      <ul className={style.memberListInfo}>
        {members.map((member, i) => {
          const name = getMemberName(member);
          return (
            <li
              className={style.listItem}
              data-hook={memberDataHook || 'index-member-entry'}
              key={`${i}-${member.urlFormat}`}
            >
              <span className={style.firstColumn}>
                {nameRenderer ? (
                  nameRenderer(member, getLink, name)
                ) : (
                  <Text
                    size="small"
                    weight="normal"
                    tagName="span"
                    onClick={() => onLinkClicked(member)}
                    dataHook="member-name"
                    link
                  >
                    <CustomLink to={getLink(member.urlFormat)}>
                      {name}
                    </CustomLink>
                  </Text>
                )}
              </span>
              <span className={style.secondColumn}>
                {member.docs && (
                  <Text size="small">
                    {getShortSummary(member.docs.summary || member.description)}
                  </Text>
                )}
              </span>
            </li>
          );
        })}
      </ul>
    );
  },
);

MembersList.displayName = 'MembersList';
